import { render, staticRenderFns } from "./OrdersCurrentByIsland.vue?vue&type=template&id=c60ad2c4&"
import script from "./OrdersCurrentByIsland.vue?vue&type=script&lang=js&"
export * from "./OrdersCurrentByIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports